import { action } from "typesafe-actions";

import { message } from "antd";

import {
  DateRangePayload,
  GatePayload,
  OrderingPayload,
  PaginatedResponse,
  PaginationPayload,
  ReportPayload,
  SearchPayload,
} from "../common_types";
import { CurrencyPayload } from "../currencies/types";
import { MarketPayload } from "../markets/types";

import { RouteItem, RoutesActionTypes } from "./types";

export const tableFetchRequest = (
  payload: DateRangePayload &
    PaginationPayload &
    MarketPayload &
    CurrencyPayload &
    OrderingPayload &
    GatePayload &
    SearchPayload
) => action(RoutesActionTypes.TABLE_FETCH_REQUEST, payload);

export const tableFetchSuccess = (payload: PaginatedResponse<RouteItem>) =>
  action(RoutesActionTypes.TABLE_FETCH_SUCCESS, payload);

export const tableFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(RoutesActionTypes.TABLE_FETCH_ERROR);
};

export const reportGeneratorTaskCreateRequest = (
  payload: ReportPayload &
    DateRangePayload &
    MarketPayload &
    CurrencyPayload &
    OrderingPayload &
    GatePayload &
    SearchPayload
) => action(RoutesActionTypes.GENERATE_REPORT_REQUEST, payload);
